import React from "react";
import JSONNode from "./JSONNode";
import type { CommonExternalProps, ShouldExpandNodeInitially } from "./types";
interface Props extends Partial<CommonExternalProps> {
    data: unknown;
}
const expandRootNode: ShouldExpandNodeInitially = (_keyPath, _data, level) => level === 0;
export function JSONTree({ data: value, keyPath = ["root"], shouldExpandNodeInitially = expandRootNode, hideRoot = true, filterValue }: Props) {
    return (<ul>
            <JSONNode keyPath={hideRoot ? [] : keyPath} value={value} shouldExpandNodeInitially={shouldExpandNodeInitially} hideRoot={hideRoot} filterValue={filterValue}/>
        </ul>);
}
